import styled from '@emotion/styled'
import tw from 'twin.macro'
import { Button, Heading, getScreenSizes } from '@pretamanger/component-library'

export const AddToBagContainer = styled('div')`
  ${tw`mt-8 p-3 pb-4 md:p-0 `}
  ${tw`flex flex-row flex-nowrap justify-end items-center`}
  ${tw`md:border-t-0 md:relative`}
  ${props =>
    props.isSticky && tw`fixed bottom-0 left-0 bg-white right-0 border-t z-20`}
  button {
    ${tw`px-6`}
  }

  > :only-child {
    ${tw`ml-auto`}
  }
`

export const ContentWrapper = styled('div')`
  ${tw`mb-24`}
  > * {
    ${tw`mb-10`}
  }
`

export const Price = styled('p')`
  ${tw`text-lg text-black flex-auto md:text-right md:mx-8`}
  span {
    ${tw`text-lg text-black`}
  }
`

export const ProductTitle = styled(Heading)`
  @media (max-width: ${getScreenSizes().md}px) {
    ${tw`mb-4`}
  }
`

export const ProductImageContainer = styled('div')`
  min-width: 18rem;

  @media (min-width: ${getScreenSizes().md}px) {
    width: 22rem;
  }

  @media (min-width: ${getScreenSizes().lg}px) {
    width: 18rem;
  }
`

export const ProductImageContainerSmall = styled('div')`
  min-width: 4.375rem;
  width: 4.375rem;

  @media (min-width: ${getScreenSizes().md}px) {
    width: 10rem;
  }

  @media (min-width: ${getScreenSizes().lg}px) {
    width: 6rem;
  }
`

export const ProductDetailsWrapper = styled('div')`
  ${tw`flex flex-col md:flex-row`}
`

export const ProductDetails = styled('div')`
  ${tw`mt-12 md:ml-10 md:mt-0 lg:ml-10 flex-grow`}
`

export const ProductDescription = styled('p')``

export const AddToBagCTA = styled(Button)`
  min-width: 10rem;
  min-height: 2rem;
`
